module.exports = __webpack_public_path__ + "static/media/car.db13d04f.gif";